import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FULL_SCHEDULE } from 'constants/routesConstants'
import { BRAND, DASHBOARD, FEATURED } from 'constants/appConstants'
import { ArrowIcon } from 'assets/icons'
import { Button, Loader } from 'components/atoms'
import { ListGrid } from 'components/organisms'
import { Search } from 'components/templates'
import ContentTypes from './Components/ContentTypes'
import * as S from './styled'
import { useTheme } from 'styled-components'

const View = ({
  zone,
  events,
  featuredItems,
  searchMode,
  search,
  searchQuery,
  handleStatus,
  contentTypesArray,
  isEventsLoading,
  isFeaturedLoading,
}) => {
  const { brand } = useTheme()

  return (
    <>
      {searchMode ? (
        <Search search={search} searchQuery={searchQuery} zone={zone} handleStatus={handleStatus} />
      ) : (
        <S.MasterContainer>
          <S.SectionContainer>
            {featuredItems.length > 0 && (
              <S.SubSectionContainer>
                <S.SectionTitle>Featured</S.SectionTitle>
                <ListGrid
                  contentType={FEATURED}
                  items={featuredItems}
                  handleStatus={() => {
                    false
                  }}
                />
              </S.SubSectionContainer>
            )}
            {events.length > 0 && (
              <S.SubSectionContainer>
                <S.SectionTitle>Upcoming Events</S.SectionTitle>
                <ListGrid
                  contentType={DASHBOARD}
                  items={events}
                  handleStatus={() => {
                    false
                  }}
                />
              </S.SubSectionContainer>
            )}
          </S.SectionContainer>
          <S.MoreContainer>
            <S.ContentTypesContainer>
              <S.SectionTitle>More Content</S.SectionTitle>
              <S.ContentTypesList>
                {contentTypesArray.length > 0 && contentTypesArray.map(item => <ContentTypes item={item} key={item} />)}
              </S.ContentTypesList>
            </S.ContentTypesContainer>
            {events.length > 0 && (
              <S.FullScheduleContainer>
                <Link to={FULL_SCHEDULE}>
                  <Button
                    label='Full Schedule'
                    classBtn={'icon transparent'}
                    icon={ArrowIcon}
                    fontSize='26px'
                    fontWeight={BRAND.ATH === brand ? '600' : '650'}
                    iconWidth='17.49px'
                    iconHeight='26.72px'
                  />
                </Link>
              </S.FullScheduleContainer>
            )}
          </S.MoreContainer>
          {isEventsLoading || (isFeaturedLoading && <Loader />)}
        </S.MasterContainer>
      )}
    </>
  )
}

View.defaultProps = {
  events: [],
  featuredItems: [],
  search: [] || {},
  searchQuery: '',
  searchMode: false,
  handleStatus: () => {},
  contentTypesArray: [],
}

View.propTypes = {
  events: PropTypes.array,
  featuredItems: PropTypes.array,
  zone: PropTypes.string.isRequired,
  search: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  searchQuery: PropTypes.string,
  searchMode: PropTypes.bool,
  handleStatus: PropTypes.func,
  contentTypesArray: PropTypes.array,
  isEventsLoading: PropTypes.bool.isRequired,
  isFeaturedLoading: PropTypes.bool.isRequired,
}

export default View
